import React, { useState, useEffect } from "react"
import {
  Header,
  Button,
  Icon,
  Modal,
  Input,
} from "semantic-ui-react";
import { Editor } from "react-draft-wysiwyg";
import { useDispatch, useSelector } from "react-redux"
import { isEmpty, isNil, cloneDeep } from 'lodash'

import { setActionModal } from './modalsSlice'

import fire from "../App/fire";

const ActionModal = (props) => {
  const dispatch = useDispatch()
  const { modalType, open } = props
  const actionModalProps = useSelector(state => state.modals.actionModalProps)
  const { tab } = actionModalProps
  let reduxFireData = useSelector(state => state[`${tab}`])

  if (!isEmpty(reduxFireData) && !isNil(reduxFireData)) {
    reduxFireData = reduxFireData.data
  }
  const [modalProps, setModalProps] = useState(actionModalProps)
  useEffect(() => {
    setModalProps(actionModalProps)
  }, [actionModalProps])

  const { header, content, key } = modalProps

  const handleInputChange = (e) => {
    setModalProps({ ...modalProps, header: e.target.value })
  }

  const handleContentStateChange = (content) => {
    setModalProps({ ...modalProps, content })
  };

  const handleOnClickCancel = () => {
    dispatch(
      setActionModal({
        header: '',
        content: '',
        key: 0,
        open: false,
        type: ''
      })
    )
  }

  const handleOnClickSave = () => {
    const newData = { content: JSON.stringify(content), header }
    const reduxFireDataCopy = cloneDeep(reduxFireData)
    if (modalType === 'add') {
      reduxFireDataCopy.splice(key + 1, 0, newData);

      // firebase index/prop name does not adjust
      // if deleted indexes/prop name will loook like this 0 1 3 and 2 is deleted
      fire
        .database()
        .ref(`${tab}/fields`)
        .set(reduxFireDataCopy);

    } else {
      // edit 
      fire
        .database()
        .ref(`${tab}/fields/` + key)
        .set(newData);

      reduxFireDataCopy[key] = newData
    }

    handleOnClickCancel()
  }

  const handleContentDelete = () => {
    const reduxFireDataCopy = cloneDeep(reduxFireData)
    reduxFireDataCopy.splice(key, 1);
    fire
      .database()
      .ref(`${tab}/fields`)
      .set(reduxFireDataCopy);

    handleOnClickCancel()
  }

  const uploadImageCallBack = (file) => {
    return new Promise(
      (resolve, reject) => {
        const storage = fire.firebase_.storage()
        const uploadTask = storage.ref(`images/${file.name}`).put(file);
        uploadTask.on(
          "state_changed",
          null, // snapshot / progress
          error => {
            // Error function ...
            reject(error)
          },
          () => {
            // complete function ...
            storage
              .ref("images")
              .child(file.name)
              .getDownloadURL()
              .then(url => {
                resolve({ data: { link: url } })
              });
          }
        );
      }
    );
  }

  return modalType !== 'delete' ? (
    <Modal open={open}>
      <Modal.Header>
        <Icon name="pencil" />
        {modalType === 'add' ? 'Add' : 'Edit'}
      </Modal.Header>
      <Modal.Content>
        <Header>Header</Header>
        <Input
          fluid
          value={header}
          onChange={(e) => handleInputChange(e)}
          type="text"
        />
        <Header>Content</Header>
        <Editor
          toolbar={{
            options: ["inline", "blockType", "list", "link", "history", 'image'],
            image: {
              urlEnabled: false,
              uploadEnabled: true,
              alignmentEnabled: true,
              uploadCallback: uploadImageCallBack,
              previewImage: true,
              inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
              alt: { present: false, mandatory: false },
              defaultSize: {
                height: 'auto',
                width: 'auto',
              },
            },
            inline: {
              options: ["bold", "italic", "underline", "monospace", "strikethrough"]
            },
            list: { options: ["unordered", "ordered"] },
            link: { defaultTargetOption: "_blank", options: ["link"] }
          }}
          initialContentState={content}
          onContentStateChange={handleContentStateChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={handleOnClickCancel}>
          <Icon name="cancel" /> Cancel
          </Button>
        <Button
          color="green"
          onClick={handleOnClickSave}
        >
          <Icon name="save" /> Save
        </Button>
      </Modal.Actions>
    </Modal>
  ) : (
      <Modal open={open} size="small">
        <Modal.Content>
          <h4>Are you sure you want to delete content?</h4>
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" onClick={handleOnClickCancel}>
            Cancel
          </Button>
          <Button
            color="red"
            onClick={handleContentDelete}
          >
            Delete
          </Button>
        </Modal.Actions>
      </Modal>
    )
}

export default ActionModal